import React from 'react';
import { RefreshCcw } from 'lucide-react';
import PolicyLayout, { Section, P, Li, Ul } from './PolicyLayout';

export default function RefundPage() {
  return (
    <PolicyLayout
      title="Refund & Cancellation Policy"
      subtitle="Understand how we handle refunds and cancellations"
      icon={RefreshCcw}
    >
      <Section title="Overview">
        <P>
          Shine Jewellery is committed to transparent and fair refund practices. Please read this
          policy carefully before making any investment or transaction on the Platform.
        </P>
      </Section>

      <Section title="Investment Refunds">
        <Ul>
          <Li>
            <strong style={{ color: '#fff' }}>Pending investments:</strong> If your deposit is
            still in "Pending" status and has not been approved by admin, you may request a
            cancellation and full refund within 24 hours of the transaction.
          </Li>
          <Li>
            <strong style={{ color: '#fff' }}>Approved investments:</strong> Once an investment is
            approved, it is considered active and cannot be directly refunded. You may raise a
            Withdrawal Request to access your funds per the withdrawal policy.
          </Li>
          <Li>
            <strong style={{ color: '#fff' }}>Failed transactions:</strong> If your payment was
            deducted but the investment was not credited, the amount will be automatically refunded
            within 5–7 business days by your bank or Razorpay.
          </Li>
        </Ul>
      </Section>

      <Section title="Refund Process">
        <Ul>
          <Li>Contact us at support@shinejewellery.in with your transaction ID and details.</Li>
          <Li>All refund requests are reviewed within 2 business days.</Li>
          <Li>Approved refunds are credited back to the original payment method used.</Li>
          <Li>Refund processing time: 5–10 business days depending on your bank or card issuer.</Li>
        </Ul>
      </Section>

      <Section title="Non-Refundable Items">
        <Ul>
          <Li>Payment gateway transaction fees charged by Razorpay.</Li>
          <Li>GST and applicable taxes levied on services.</Li>
          <Li>Making charges on redeemed gold jewellery once fabrication has begun.</Li>
          <Li>Investments that have been approved and have already earned returns.</Li>
        </Ul>
      </Section>

      <Section title="Cancellation Policy">
        <Ul>
          <Li>
            Gold jewellery redemption orders can be cancelled up to 48 hours before the scheduled
            pickup or delivery date.
          </Li>
          <Li>
            Cancellations after fabrication has begun will attract a partial charge for labour
            and materials used.
          </Li>
          <Li>
            Withdrawal requests that are in "Pending" status can be cancelled through the Platform
            before admin processing begins.
          </Li>
        </Ul>
      </Section>

      <Section title="Dispute Resolution">
        <P>
          For payment disputes, please contact us before raising a chargeback with your bank.
          Chargebacks initiated without prior communication may result in temporary account
          suspension while the matter is investigated.
        </P>
        <P>Contact: support@shinejewellery.in</P>
      </Section>
    </PolicyLayout>
  );
}
